export default {
  message: {
    "error": "অপস! কিছু ভুল হয়েছে।",
    "Sorrysomeerrorsoccurred": "একটি অপ্রত্যাশিত ত্রুটি হয়েছে। আপনি ভাষা পরিবর্তন করার চেষ্টা করতে পারেন অথবা অ্যাপটি বন্ধ করে আবার শুরু করতে পারেন।",
    "quit": "বিরতি দিন",
    "language": "ভাষা",
    "Youcanchangethelanguagehere": "আপনি এখানে ভাষা পরিবর্তন করতে পারেন!",
    "current": "মৌসুমী",
    "home": "হোম",
    "friends": "বন্ধুরা",
    "wallet": "ওয়ালেট",
    "aboutus": "আমাদের সম্পর্কে",
    "Sharewithfriends": "বন্ধুদের সাথে শেয়ার করুন",
    "copyFailure": "কপি ব্যর্থ",
    "copySuccess": "কপি সফল",
    "Claimreward": "পুরস্কার সংগ্রহ করুন",
    "DailyLogin": "দৈনিক লগইন",
    "noInvitationsYet": "এখনো কোনো আমন্ত্রণ নেই",
    "LoadMore": "আরো লোড করুন",
    "WatchAD": "বিজ্ঞাপন দেখুন",
    "continue": "অব্যাহত রাখুন",
    "Congratulations": "অভিনন্দন",
    "MyFriends": "আমার বন্ধুরা",
    "Invitefriends": "বন্ধুদের আমন্ত্রণ দিন",
    "Invitepremiumfriends": "প্রিমিয়াম বন্ধুরা আমন্ত্রণ দিন",
    "DailyTasks": "দৈনিক কাজ",
    "inviteDesc": "প্রতি বন্ধু আমন্ত্রণ করার জন্য +{num} ${name}",
    "DailyTasksDesc": "আরো এয়ারড্রপ পেতে কাজগুলো সম্পূর্ণ করুন",
    "SponsorsandPartners": "স্পনসর এবং অংশীদার",
    "Receivingwallet": "প্রাপ্তির ওয়ালেট",
    "Enterwalletaddress": "{name} ওয়ালেট ঠিকানা প্রবেশ করুন",
    "Claim": "পুরস্কার নিন",
    "Booster": "বুস্টার",
    "RentPeriod": "ভাড়া কাল",
    "days30": "30 দিন",
    "Dailyprofit": "দৈনিক লাভ",
    "Totalprofit": "মোট লাভ",
    "Quantity": "পরিমাণ",
    "RentPrice": "ভাড়া মূল্য",
    "RentMiner": "মাইনারের জন্য ভাড়া",
    "Insufficient": "যথেষ্ট আমন্ত্রিত নেই",
    "InsufficientMsg": "আপনাকে আরো আনুষাঙ্গিক উপার্জনের জন্য {num} বন্ধুদের আমন্ত্রণ জানাতে হবে।",
    "Settings": "সেটিংস",
    "copyid": "আইডি কপি করুন",
    "UpgradeSuccessfully": "সফলভাবে আপগ্রেড",
    "Name": "নাম",
    "userinfo": "ব্যবহারকারীর তথ্য",
    "disconnect": "সংযোগ বিচ্ছিন্ন করুন",
    "Startmining": "খনন শুরু করুন",
    "Welcome": "স্বাগতম {name}",
    "Withdrawal": "অর্থ প্রত্যাহার",
    "Minimumamount": "নূন্যতম পরিমাণ",
    "Networkfee": "নেটওয়ার্ক ফি",
    "Enteramount": "পরিমাণ লিখুন",
    "Submit": "জমা দিন",
    "MinimumTip": "বিশুদ্ধ উত্তোলনের পরিমাণ খুবই কম। সর্বনিম্ন উত্তোলনের পরিমাণ: {num}",
    "MaximumTip": "যথেষ্ট পরিমাণ নেই, আপনি সর্বাধিক উত্তোলন করতে পারবেন: {num}",
    "SubmittedTip": "জমা দেওয়া হয়েছে, ৩০-৬০ কার্যদিবসের মধ্যে প্রক্রিয়া হওয়ার প্রত্যাশা",
    "WebSubmittedTip": "জমা দেওয়া হয়েছে, আমরা যত তাড়াতাড়ি সম্ভব এটি প্রক্রিয়া করব।",
    "WithdrawStatus": "স্থিতি",
    "Submissiontime": "জমার সময়",
    "WithdrawAwaitTip": "* এটি ৩০-৬০ কার্যদিবস লাগবে বলে অনুমান করা হয়েছে। বেশী বন্ধুদের আমন্ত্রণ জানালে পর্যালোচনা প্রক্রিয়া দ্রুত হবে।",
    "WebWithdrawAwaitTip": "* এটি ২৪-৪৮ ঘণ্টা লাগবে বলে অনুমান করা হয়েছে। বেশী বন্ধুদের আমন্ত্রণ জানালে পর্যালোচনা প্রক্রিয়া দ্রুত হবে।",
    "Processing": "প্রক্রিয়াকরণ হচ্ছে",
    "Success": "সফল",
    "Rejection": "অস্বীকৃতি",
    "Amount": "পরিমাণ",
    "Numberoffriends": "বন্ধুর সংখ্যা: {now}/{limit}",
    "InviteTip": "আপনার প্রথম উত্তোলন করতে, আপনাকে {limit} বন্ধুদের মাইনিং অ্যাপে যোগ দিতে আমন্ত্রণ জানাতে হবে।",
    "openonphone": "আপনার ফোনে এই লিঙ্কটি খুলুন।",
    "claimTip": "যত পরিমাণ পুরস্কার পাওয়া যাবে তা খুবই কম। সর্বনিম্ন পরিমাণ পাওয়া যাবে: {num}",
    "WalletBalance": "ওয়ালেট ব্যালেন্স",
    "Withdraw": "উত্তোলন করুন",
    "SetWalletAddress": "ওয়ালেট ঠিকানা সেট করুন",
    "WithdrawalRecord": "উত্তোলনের রেকর্ড",
    "Norecords": "কোনো রেকর্ড নেই",
    "Whatis": "এটি {name} কি?",
    "All": "সব",
    "save": "সংরক্ষণ করুন",
    "successWithdrawal": "স্ক্যান সফল {num}",
    "secondsago": "{time} সেকেন্ড আগে",
    "Loading": "লোড হচ্ছে...",
    "PaymentConfirming": "লেনদেনের স্থিতি যাচাই করা হচ্ছে...",
    "Check": "যাচাই করুন",
    "CheckFail": "লেনদেন সম্পন্ন হয়নি। দয়া করে ৫ সেকেন্ড পরে আবার проверите।",
    "Addname": "'{name}' আপনার নামের সাথে যোগ করুন",
    "Restattcheck": "যাচাই করতে অ্যাপটি পুনারম্ভ করুন",
    "Copyname": "'{name}' কপি করুন",
    "SubmissionFailed": "জমা দিতে ব্যর্থ হয়েছে, দয়া করে পরে আবার চেষ্টা করুন",
    "WithdrawalReview": "উত্তোলন পর্যালোচনা",
    "select_payment_method": "পেমেন্ট পদ্ধতি নির্বাচন করুন",
    "total_amount": "মোট পরিমাণ",
    "next_step": "পরবর্তী পদক্ষেপ",
    "creating_order": "অর্ডার তৈরি হচ্ছে...",
    "order_created": "অর্ডার তৈরি হয়েছে",
    "order_status": "অর্ডারের স্থিতি",
    "order_id": "অর্ডার আইডি",
    "order_amount": "অর্ডারের পরিমাণ",
    "order_status_desc": "অর্ডারের স্থিতি বর্ণনা",
    "payment_cancelled": "পেমেন্ট বাতিল হয়েছে",
    "opening_payment": "পেমেন্ট খুলছে...",
    "payment_success": "পেমেন্ট সফল",
    "payment_failed": "পেমেন্ট ব্যর্থ হয়েছে",
    "payment_pending": "পেমেন্ট মুলতুবি",
    "payment_processing": "পেমেন্ট প্রক্রিয়াধীন",
    "create_order_failed": "অর্ডার তৈরি ব্যর্থ হয়েছে",
    "creating_ton_order": "TON অর্ডার তৈরি করা হচ্ছে...",
    "check_payment_status": "পেমেন্ট স্থিতি যাচাই করা হচ্ছে...",
    "use_ton_payment": "TON পেমেন্ট ব্যবহার করুন",
    "connect_wallet": "ওয়ালেট সংযোগ করুন",
    "start_transaction": "লেনদেন শুরু করুন",
    "address": "ঠিকানা",
    "amount_ton": "রাশি TON",
    "copy": "কপি করুন",
    "comment_memo": "মন্তব্য নোট",
    "comment_memo_desc": "দয়া করে মন্তব্য নোটটি প্রবেশ করুন",
    "comment_memo_placeholder": "মন্তব্য নোট প্রবেশ করুন",
    "amount": "রাশি",
    "wallet_address": "ওয়ালেট ঠিকানা",
    "you_can_choose_to_connect_wallet_to_pay": "আপনি অর্থ প্রদান করতে ওয়ালেট সংযুক্ত করতে পারেন",
    "or_manually_transfer_to_the_above_address": "অথবা উভয় ঠিকানায় ম্যানুয়ালি স্থানান্তর করুন (মনে রাখবেন যে রাশি এবং নোট অবশ্যই একেবারে একই হতে হবে)",
    "transaction_success": "লেনদেন সফল",
    "transaction_failed": "লেনদেন ব্যর্থ হয়েছে",
    "transaction_error": "লেনদেন ত্রুটি",
    "transaction_status": "লেনদেন স্থিতি",
    "transaction_id": "লেনদেন আইডি",
    "transaction_amount": "লেনদেনের রাশি",
    "transaction_status_desc": "লেনদেন স্থিতি বর্ণনা",
    "miner_detail": "মাইনার বিস্তারিত",
    "rent_period": "ভাড়া কাল",
    "days": "{days} দিন",
    "daily_yield": "দৈনিক ফেরত",
    "total_yield": "মোট ফেরত",
    "invite_friends": "বন্ধুকে আমন্ত্রণ জানান",
    "price": "দাম",
    "rent": "ভাড়া",
    "free_claim": "ফ্রি পুরস্কার",
    "redeem": "পুনঃপ্রাপ্তি",
    "buy": "ভাড়া",
    "invite_friends_not_enough": "বন্ধুদের আমন্ত্রণ যথেষ্ট নয়",
    "redeem_success": "পুনঃপ্রাপ্তি সফল",
    "redeem_failed": "পুনঃপ্রাপ্তি ব্যর্থ",
    "rent_success": "ভাড়া সফল",
    "rent_failed": "ভাড়া ব্যর্থ",
    "TotalPower": "মোট শক্তি",
    "MaxQuantity": "সর্বাধিক মান পৌঁছেছে",
    "Running": "চলমান",
    "Stop": "বন্ধ করুন",
    "Withdrawalunlock": "ব্যাংক উত্তোলন আনলককরণ",
    "Close": "বন্ধ করুন",
    "Delivering": "পাঠানো হচ্ছে",
    "Duetothelargenumber": "প্রাপকوںের সংখ্যা বেশি হওয়ায়, আপনার এয়ারড্রপ ১৫-২০ কার্যদিবসে আসার আশা রয়েছে",
    "WithdrawalunlockTip": "আপনাকে ব্যাংক উত্তোলন আনলক করতে {num} আমন্ত্রিত বন্ধু দরকার হবে কাজ সম্পন্ন করতে/ওয়ালেট বেঁধে রাখতে",
    "mining_title": "রবট",
    "Upgrade": "আপগ্রেড",
    "partner": "সঙ্গী",
    "faq": "প্রশ্ন ও উত্তর",
    "task": "কাজ",
    "OpenRobot": "রোবট খোলা",
    "MyRobot": "মার রোবট",
    "Level": "স্তর",
    "Commission": "কমিশন",
    "DirectFriends": "সরাসরি বন্ধু",
    "Feedback": "প্রতিক্রিয়া",
    "Pleaseenteryouremailaddress": "আপনার ইমেল ঠিকানা প্রবেশ করুন",
    "Inputfeedbackcontent": "প্রতিক্রিয়া বিষয়বস্তু প্রবেশ করুন",
    "Submitfeedback": "প্রতিক্রিয়া জমা দিন",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "প্রতিক্রিয়া সফলভাবে জমা হয়েছে, আপনার মূল্যবান প্রতিক্রিয়ার জন্য ধন্যবাদ",
    "Feedbacksubmissionfailed,pleaseretriy": "প্রতিক্রিয়া জমা দেওয়া ব্যর্থ হয়েছে, আবার চেষ্টা করুন",
    "Addressformaterror": "ঠিকানা ফর্ম্যাটের ত্রুটি",
    "Readclipboardfailed": "ক্লিপবোর্ড পড়তে ব্যর্থ",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "আপনি ইতিমধ্যে আজ প্রতিক্রিয়া দিয়েছেন, দয়া করে আগামীকাল ফিরে আসুন",
    "Record": "রেকর্ড",
    "Newuserguidance": "স্বাগতম ট্যুর দেখুন",
    "Usetonwallet": "TON ওয়ালেট ব্যবহার করুন",
    "Reward": "রিওয়ার্ড",
    "Connectwallet": "ওয়ালেট সংযুক্ত করুন",
    "Notconnected": "সংযুক্ত নয়",
    "Disconnect": "অসংযুক্ত করা",
    "AboutTAI": "টোকেনের বিবরণ",
    "WithdrawalRecordDesc": "উৎপাদন রেকর্ড",
    "StartAItrading": "AI ট্রেডিং শুরু করুন",
    "Next": "পরবর্তী",
    "Start": "শুরু করুন",
    "WithdrawalSuccess": "উৎপাদন সফল",
    "WithdrawalFail": "উৎপাদন ব্যর্থ",
    "Max": "সর্বোচ্চ",
    "WithdrawalRecords": "উৎপাদন রেকর্ডসমূহ",
    "Commissionrules": "কমিশন নিয়ম",
    "Mycommission": "আমার কমিশন",
    "Shop": "দোকান",
    "BuyDifferentAIrobots": "দ্রুত স্ক্যানের জন্য কম্পিউট ডিভাইস আপগ্রেড করুন!",
    "CurrentRunningAIrobots": "বর্তমানে চলমান AI রোবটসমূহ",
    "DailyProfit": "দৈনিক লাভ",
    "Buy": "কিনুন",
    "ValidityPeriod": "মেয়াদকাল",
    "Days": "দিন",
    "Price": "মূল্য",
    "APY": "APY",
    "NoRobot": "কোনো কম্পিউট শক্তি নেই",
    "RemainingTime": "অবশিষ্ট সময়",
    "InviteandEarn": "আমন্ত্রণ করুন এবং উপার্জন করুন",
    "InvitDec": "আপনার বন্ধুদের AI ট্রেডিংয়ে যোগ দিতে আমন্ত্রণ জানান এবং USDT কমিশন এবং এয়ারড্রপ টোকেন একসাথে উপার্জন করুন!",
    "ShareToGroups": "গ্রুপে শেয়ার করুন",
    "Select_payment_method": "পেমেন্ট পদ্ধতি নির্বাচন করুন",
    "twa_pay_tip_with_memo": "দয়া করে নিশ্চিত করুন যে ঠিকানা, পরিমাণ এবং স্মারক স্থানান্তরের জন্য সঙ্গতিপূর্ণ।",
    "twa_pay_tip": "দয়া করে নিশ্চিত করুন যে ঠিকানা এবং পরিমাণ স্থানান্তরের জন্য সঠিক।",
    "twa_pay_tip_placeholder": "মন্তব্য স্মারক লিখুন",
    "twa_pay_tip_placeholder_with_memo": "স্মারক সহ মন্তব্য স্মারক লিখুন",
    "twa_pay_tip_placeholder_without_memo": "স্মারক ছাড়া মন্তব্য স্মারক লিখুন",
    "twa_pay_tip_placeholder_with_memo_placeholder": "স্মারক সহ মন্তব্য স্মারক লিখুন",
    "twa_pay_tip_placeholder_without_memo_placeholder": "স্মারক ছাড়া মন্তব্য স্মারক লিখুন",
    "realtime_ai": "রিয়েল-টাইম AI ট্রেডিং",
    "check_transaction_status": "লেনদেনের অবস্থান পরীক্ষা করুন",
    "transaction_wait": "লেনদেন প্রক্রিয়াধীন। আপনি অ্যাপটি বন্ধ করতে পারেন। এটি সম্পন্ন হলে একটি বার্তা আপনাকে জানাবে।",
    "Pleaseenteravalidemailaddress": "দয়া করে একটি বৈধ ইমেইল ঠিকানা প্রবেশ করুন",
    "max_robot_tip": "ক্রয়ের সীমা পূর্ণ হয়েছে — ব্যবসা চালিয়ে যেতে অন্য একটি পরিকল্পনা চেষ্টা করুন!",
    "connectFailure": "সংযোগ করতে ব্যর্থ হয়েছে",
    "connectSuccess": "সংযোগ সফল হয়েছে",
    "PayNow": "এখন পরিশোধ করুন",
    "min_withdrawal_amount": "ন্যূনতম প্রত্যাহারের পরিমাণ {num} {coin_name}",
    "max_withdrawal_amount": "অধিকতম প্রত্যাহারের পরিমাণ {num} {coin_name}",
    "balance_not_enough": "আপনার এই প্রত্যাহারের জন্য যথেষ্ট ব্যালেন্স নেই।",
    "Numberofgroups": "গ্রুপের সংখ্যা: {now}/{limit}",
    "Withdraw_success": "প্রত্যাহার সফল হয়েছে",
    "allProfit": "মোট লাভ",
    "AnnualProfit": "বার্ষিক লাভ",
    "ScanWallet": "পার্স স্ক্যান করুন",
    "wallet_check": "wallet_check",
    "Found": "মিলেছে",
    "ScanSpeed": "স্ক্যান গতিবেগ",
    "MyComputingPower": "কম্পিউট",
    "Scanning": "স্ক্যান করা হচ্ছে!",
    "WithdrawDetail": "অবসরে তথ্য",
    "ScanSuccess": "আপনার স্ক্যান সফলতার হার বৃদ্ধি পেয়েছে!",
    "TaskDescription": "আপনার স্ক্যান সাফল্যের হার বাড়ানোর জন্য কাজ সম্পন্ন করুন!",
    "InitializingMiningSystem": "স্ক্যান সিস্টেম প্রস্তুত হচ্ছে...",
    "NoWithdrawalRecord": "কোনও টাকা তোলা রেকর্ড নেই",
    "Invite": "আবশ্যক আমন্ত্রণগুলি",
    "Free": "মুক্ত",
    "Confirm": "নিশ্চিত করুন",
    "RefreshTasks": "কাজগুলি রিফ্রেশ করুন",
    "NumberofGroups": "গোষ্ঠীর সংখ্যা: {now}/{limit}",
    "SendMessage": "বার্তা পাঠান",
    "NumberofShares": "শেয়ার সংখ্যা: {now}/{limit}",
    "NumberofTasks": "কাজের সংখ্যা: {now}/{limit}",
    "CompleteTask": "কাজ সম্পন্ন করুন",
    "Accelerated": "দ্রুত",
    "Accelerated_withdrawals_success": "দ্রুত উত্তোলন সফলভাবে",
    "GoBuy": "কিনতে যান",
    "SpeedUpScan": "গতিবেগ বৃদ্ধি করুন",
    "Earnings": "আয়",
    "learnMore": "আরও জানুন",
    "claimSuccess": "পুরস্কার সফলভাবে পাওয়া গেছে",
    "claimFailed": "পুরস্কার পেতে ব্যর্থ, অনুগ্রহ করে আবার চেষ্টা করুন",
    "noDividends": "পাওয়ার জন্য কোন ডিভিডেন্ড নেই",
    "dividendsInfoFallback": "অ্যাতি বান্ধবকে আমন্ত্রণ জানিয়ে রেফারাল পুরস্কার অর্জন করুন"
}};